import { Form, Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { useIntl } from 'react-intl';
import '../../css/DppForm.css';

// Validation schema
const schema = z.object({
  format: z.enum(['pdf', 'json'], {
    required_error: 'Format is required',
  }),
});

const DownloadForm = ({ onDownload, onCancel }) => {
  const intl = useIntl();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, isValid },
    reset,
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      format: 'pdf',
    },
    mode: 'onTouched',
  });

  const selectedFormat = watch('format');

  const handleCancel = () => {
    reset();
    onCancel?.();
  };

  const handleDownload = (data) => {
    onDownload?.(data);
    reset();
  };

  return (
    <Form onSubmit={handleSubmit(handleDownload)} noValidate className="dpp-form">
      <Form.Group className="mb-4" controlId="format">
        <Form.Label>{intl.formatMessage({ id: 'choose_download_type' })}</Form.Label>
        <div className="dpp-radio-group">

            <label
              htmlFor="pdf"
              className={`dpp-radio-card ${
                selectedFormat === 'pdf' ? 'selected' : ''
              }`}
            >
              <input
                type="radio"
                id="pdf"
                value="pdf"
                {...register('format')}
              />
              <div className="card-content">
                <div className="icon">📄</div>
                <div className="text">
                  <h5>{intl.formatMessage({ id: 'pdf_format' })}</h5>
                  <p>{intl.formatMessage({ id: 'download_as_pdf_description' })}</p>
                </div>
              </div>
            </label>

            <label
              htmlFor="json"
              className={`dpp-radio-card ${
                selectedFormat === 'json' ? 'selected' : ''
              }`}
            >
              <input
                type="radio"
                id="json"
                value="json"
                {...register('format')}
              />
              <div className="card-content">
                <div className="icon">📋</div>
                <div className="text">
                  <h5>{intl.formatMessage({ id: 'json_format' })}</h5>
                  <p>{intl.formatMessage({ id: 'download_as_json_description' })}</p>
                </div>
              </div>
            </label>
        </div>
        {errors.format && (
          <Form.Control.Feedback type="invalid" className="d-block">
            {errors.format.message}
          </Form.Control.Feedback>
        )}
      </Form.Group>

      <div className="d-flex justify-content-end gap-2">
        <Button
          variant="outline-secondary"
          onClick={handleCancel}
          className="dpp-modal-button"
        >
          {intl.formatMessage({ id: 'cancel' })}
        </Button>
        <Button
          variant="primary"
          type="submit"
          disabled={!isValid}
          className="dpp-modal-button"
        >
          {intl.formatMessage({ id: 'download' })}
        </Button>
      </div>
    </Form>
  );
};

export default DownloadForm;